import type React from "react";
import { ExpandableText } from "@/components/common/ExpandableText";
import { PostCardEditForm } from "@/components/common/PostCardEditForm";
import { EventLinkPreviewProvider } from "@/contexts/EventLinkPreviewContext";
import type { EventApiResponse } from "@/lib/humhub-api/types";

interface PostCardBodyProps {
  isCompact: boolean;
  firstLine: string;
  isEditMode: boolean;
  editedMessage: string;
  content: string;
  isSubmittingEdit: boolean;
  onEditedMessageChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onCancelEdit: () => void;
  onSubmitEdit: () => Promise<void>;
  onEventClick?: (eventData: EventApiResponse) => void;
  studyGroupId?: number;
}

export const PostCardBody: React.FC<PostCardBodyProps> = ({
  isCompact,
  firstLine,
  isEditMode,
  editedMessage,
  content,
  isSubmittingEdit,
  onEditedMessageChange,
  onKeyDown,
  onCancelEdit,
  onSubmitEdit,
  onEventClick,
  studyGroupId,
}) => {
  if (isCompact) {
    return (
      <p className="line-clamp-1 text-sm text-variable-collection-black-gray">
        {firstLine}
      </p>
    );
  }

  if (isEditMode) {
    return (
      <PostCardEditForm
        value={editedMessage}
        originalContent={content}
        isSubmitting={isSubmittingEdit}
        onChange={onEditedMessageChange}
        onKeyDown={onKeyDown}
        onCancel={onCancelEdit}
        onSubmit={onSubmitEdit}
      />
    );
  }

  if (onEventClick || studyGroupId) {
    return (
      <EventLinkPreviewProvider
        onEventClick={onEventClick}
        currentStudyGroupId={studyGroupId ? String(studyGroupId) : undefined}
      >
        <ExpandableText content={content} />
      </EventLinkPreviewProvider>
    );
  }

  return <ExpandableText content={content} />;
};
